<template>
  <div class="hint-wrapper">
    <Transition name="hint" mode="out-in">
      <!-- Full pill when hints are on -->
      <div v-if="visible && hint" :key="hint" class="hint-box">
        <v-icon size="16" class="hint-icon">mdi-lightbulb-on-outline</v-icon>
        <span class="hint-text">{{ hint }}</span>
        <button class="hint-toggle" title="Turn off hints" @click.stop="emit('toggle')">
          <v-icon size="14">mdi-eye-off-outline</v-icon>
        </button>
      </div>

      <!-- Collapsed lightbulb when hints are off -->
      <button
        v-else-if="!visible"
        key="restore"
        class="hint-restore"
        title="Turn on hints"
        @click.stop="emit('toggle')"
      >
        <v-icon size="16">mdi-lightbulb-outline</v-icon>
      </button>
    </Transition>
  </div>
</template>

<script setup lang="ts">
defineProps<{ hint: string | null; visible: boolean }>();
const emit = defineEmits<{ toggle: [] }>();
</script>

<style lang="scss" scoped>
.hint-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.hint-box {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: rgba(20, 20, 20, 0.72);
  color: rgba(255, 255, 255, 0.93);
  font-size: 13.5px;
  font-weight: 500;
  padding: 7px 8px 7px 13px;
  border-radius: 24px;
  user-select: none;
  white-space: nowrap;
  backdrop-filter: blur(6px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
  letter-spacing: 0.01em;
  pointer-events: all;
}

.hint-icon {
  opacity: 0.78;
  flex-shrink: 0;
}

.hint-text {
  pointer-events: none;
}

.hint-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: rgba(255, 255, 255, 0.55);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, color 0.15s ease;
  padding: 0;
  margin-left: 2px;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
    color: rgba(255, 255, 255, 0.9);
  }
}

.hint-restore {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: rgba(20, 20, 20, 0.62);
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  backdrop-filter: blur(6px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
  transition: background 0.15s ease, color 0.15s ease;
  padding: 0;
  pointer-events: all;

  &:hover {
    background: rgba(20, 20, 20, 0.85);
    color: rgba(255, 255, 255, 0.9);
  }
}

// Fade-slide transition for hint text changes and visibility
.hint-enter-active,
.hint-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}
.hint-enter-from {
  opacity: 0;
  transform: translateY(4px);
}
.hint-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
